// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/create_non_medical_inventory_price.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.CreateNonMedicalInventoryPriceRequest
 */
export class CreateNonMedicalInventoryPriceRequest extends Message<CreateNonMedicalInventoryPriceRequest> {
  /**
   * The ID of the non-medical inventory item
   *
   * @generated from field: string inventory_id = 1;
   */
  inventoryId = "";

  /**
   * The price of the non-medical inventory item
   *
   * @generated from field: float price = 2;
   */
  price = 0;

  /**
   * The date when the price becomes effective
   *
   * @generated from field: int64 effective_date = 3;
   */
  effectiveDate = protoInt64.zero;

  constructor(data?: PartialMessage<CreateNonMedicalInventoryPriceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateNonMedicalInventoryPriceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inventory_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "effective_date", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateNonMedicalInventoryPriceRequest {
    return new CreateNonMedicalInventoryPriceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateNonMedicalInventoryPriceRequest {
    return new CreateNonMedicalInventoryPriceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateNonMedicalInventoryPriceRequest {
    return new CreateNonMedicalInventoryPriceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateNonMedicalInventoryPriceRequest | PlainMessage<CreateNonMedicalInventoryPriceRequest> | undefined, b: CreateNonMedicalInventoryPriceRequest | PlainMessage<CreateNonMedicalInventoryPriceRequest> | undefined): boolean {
    return proto3.util.equals(CreateNonMedicalInventoryPriceRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CreateNonMedicalInventoryPriceResponse
 */
export class CreateNonMedicalInventoryPriceResponse extends Message<CreateNonMedicalInventoryPriceResponse> {
  constructor(data?: PartialMessage<CreateNonMedicalInventoryPriceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateNonMedicalInventoryPriceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateNonMedicalInventoryPriceResponse {
    return new CreateNonMedicalInventoryPriceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateNonMedicalInventoryPriceResponse {
    return new CreateNonMedicalInventoryPriceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateNonMedicalInventoryPriceResponse {
    return new CreateNonMedicalInventoryPriceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateNonMedicalInventoryPriceResponse | PlainMessage<CreateNonMedicalInventoryPriceResponse> | undefined, b: CreateNonMedicalInventoryPriceResponse | PlainMessage<CreateNonMedicalInventoryPriceResponse> | undefined): boolean {
    return proto3.util.equals(CreateNonMedicalInventoryPriceResponse, a, b);
  }
}

